import React from "react"
import { Link } from "react-router-dom";
const Shortcuts = () => {
    return (
        <div className="col-xl-6">
            <div className="global_cardbox">
                <div className="global_card_header">
                    <div className="global_head_tag">
                        <span>
                            <i className="fa-solid fa-share"></i>
                        </span>
                        Shortcuts
                    </div>
                </div>
                <div className="card_body">
                    <ul className="shortut_listing">
                        <li>
                        <Link to="/create-clients">
                                <i className="fa-solid fa-user-plus"></i>
                          </Link>
                            <span>Create Client</span>
                        </li>
                        <li>
                        <Link to="/personal-folders">
                                <i className="fa-solid fa-folder"></i>
                            </Link>
                            <span>Personal Folders</span>
                        </li>
                        <li>
                        <Link to="/shared-folders">
                                <i className="fa-solid fa-folder-open"></i>
                            </Link>
                            <span>Shared Folders</span>
                        </li>
                        <li>
                        <Link to="/favorite-folders">
                                <i className="fa-solid fa-star"></i>
                            </Link>
                            <span>Favorites</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Shortcuts;
